/**
 * The eight colours a tag can be, and the one place that turns a colour name into styles.
 *
 * WHY EIGHT AND WHY THESE. Enough to tell "rush" from "unhappy client" across a board at a glance,
 * few enough that nobody deliberates over which shade of blue. Two are the theme's own (gold, teal);
 * the rest were chosen by measuring, not by eye: every one clears 4.5:1 against the worst surface a
 * chip sits on, in BOTH themes. The values and their measured ratios live in index.css, once, with
 * a `.light` block that swaps them — so a chip is legible in light mode without this file knowing
 * which mode it is in.
 *
 * WHY CSS VARIABLES AND NOT TAILWIND CLASSES. A stock Tailwind shade is one fixed colour: whatever
 * reads well on the dark board is too pale on the light one. The variable indirection is what makes
 * one colour name work in both.
 */

// Order matters: it is the order of the swatches, and `slate` leads because it is the default --
// a tag nobody has coloured yet should look deliberately plain rather than randomly assigned.
export const TAG_COLORS = [
  { key: 'slate', label: 'Slate' },
  { key: 'red', label: 'Red' },
  { key: 'amber', label: 'Amber' },
  { key: 'gold', label: 'Gold' },
  { key: 'green', label: 'Green' },
  { key: 'teal', label: 'Teal' },
  { key: 'blue', label: 'Blue' },
  { key: 'violet', label: 'Violet' },
];

export const TAG_COLOR_KEYS = TAG_COLORS.map(c => c.key);
export const DEFAULT_TAG_COLOR = 'slate';

/** Inline styles for a tag chip. An unknown or missing colour falls back to the default rather
 *  than rendering an invisible chip built from an undefined variable. */
export function tagChipStyle(color) {
  const c = TAG_COLOR_KEYS.includes(color) ? color : DEFAULT_TAG_COLOR;
  return {
    color: `var(--tag-${c})`,
    backgroundColor: `var(--tag-${c}-bg)`,
    borderColor: `var(--tag-${c}-br)`,
  };
}

/** Just the ink, for a swatch or an icon. */
export function tagInk(color) {
  const c = TAG_COLOR_KEYS.includes(color) ? color : DEFAULT_TAG_COLOR;
  return `var(--tag-${c})`;
}
